import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import { loadingClass } from '@/lib/helpers';

const DEFAULT_CREDENTIALS = (window as any).rootConfig.EMBEDDED ? {} : {
  mail: "arnaud-test-valideur@apyx.fr",
  pass: "a"
}

@Component
export default class LoginIndex extends Vue {

  @Action login;

  private mail:string = DEFAULT_CREDENTIALS.mail || "";
  private pass:string = DEFAULT_CREDENTIALS.pass || "";

  protected loading: boolean = false;
  protected loginError: boolean = false;

  async created() {
    if( process.env.NODE_ENV === "development"){
      setTimeout(async () => {
        //await this.onSubmitLogin();
      }, 500);
    }
  }

  async onSubmitLogin(e) {
    e.preventDefault();
    this.loading = true;
    const ok = await this.login({mail: this.mail, pass: this.pass });
    if (ok) {
      this.$router.push({name: "index"});
    } else {
      this.loginError = true;
      this.loading = false;
    }
  }

  render() {
    return (
    <section class="login-index">
      <div class="container">
        <div class="columns is-centered">
          <article class="card is-rounded">
            <div class="card-image">
              <figure>
                <img src={require('../../../../public/assets/images/bandeau_generique_page.jpg')}/>
              </figure>
              <div class="figure-overlay">
                <div class="title">
                  Saisie cavités
                </div>
              </div>
            </div>
            <div class="card-content is-airy-v">
              
              {this.loginError ? (
                <p class="has-text-danger"><small>L'identification a échoué. Vérifiez vos paramètres.</small></p>
              ) : (
                <p class="has-text-grey-dark"><small>IDENTIFICATION</small></p>
              )}
              <form onSubmit={this.onSubmitLogin} class="is-airy-v">
                <p class="control has-icon">
                  <input class="input" type="email" v-model={this.mail} placeholder="Email"/>
                  <i class="fa fa-envelope"></i>
                </p>
                <p class="control has-icon">
                  <input class="input" type="password" v-model={this.pass} placeholder="Mot de passe"/>
                  <i class="fa fa-lock"></i>
                </p>
                <p class="control">
                  <button class={`button is-primary is-medium is-fullwidth ${loadingClass(this.loading)}`}
                    type="submit">
                    <i class="fa fa-user"></i>
                    Connexion
                  </button>
                </p>
              </form>
            </div>
            <div class="card-footer">
              <div class="logos">
                <img src={require('../../../../public/assets/images/mtes_2017.jpg')} style="width: 84px"/>
                <img src={require('../../../../public/assets/images/logo-brgm.png')} style="height: 60px"/>
              </div>
            </div>
          </article>
        </div>
        <div class="columns is-centered">
          
        </div>
      </div>
    </section>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-04f79cce/index.tsx" });